export const BRAND = {
  name: "TASSEI",
  domain: "TASSEI.in",
  fullForm: "Talent Acceleration Skill Success Ecosystem of India",
  tagline: "Sapno Se Safalta Tak",
  phone: "+91 9910704971",
  phoneRaw: "919910704971",
  email: "admin@tassei.in",
  website: "www.tassei.in",
  logo: "https://customer-assets.emergentagent.com/job_skill-success-hub/artifacts/59zu9twr_215721-removebg-preview.png",
};

export const WA_LINK = (msg = "Hi TASSEI, I want a free consultation") =>
  `https://wa.me/${BRAND.phoneRaw}?text=${encodeURIComponent(msg)}`;

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Courses", to: "/courses" },
  { label: "Events", to: "/events" },
  { label: "Downloads", to: "/downloads" },
  { label: "Mentor", to: "/become-mentor" },
  { label: "Careers", to: "/careers" },
  { label: "Partner", to: "/partner" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];

// Subset shown inline in the desktop header (compact); drawer keeps the full NAV_LINKS
export const MAIN_NAV = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Courses", to: "/courses" },
  { label: "Downloads", to: "/downloads" },
  { label: "Careers", to: "/careers" },
  { label: "FAQ", to: "/faq" },
];

export const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_skill-success-hub/artifacts/qaqjet42_1782511996262.png";
export const HANDSHAKE_IMAGE = "https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=1200&q=80";

export const ABOUT = {
  kanji: "達成",
  romaji: "Tassei",
  jpMeaning: "Achievement · Accomplishment · Attainment",
  jpDescription:
    "達成 (Tassei) is a Japanese word that means 'achievement' or 'reaching a goal after effort'. It combines 達 (tatsu — to reach, to arrive) and 成 (sei — to become, to succeed, to complete). Together they capture the very heart of our brand: reaching a state of real, completed success.",
  acronym: [
    { letter: "T", word: "Talent" },
    { letter: "A", word: "Acceleration" },
    { letter: "S", word: "Skill" },
    { letter: "S", word: "Success" },
    { letter: "E", word: "Ecosystem of" },
    { letter: "I", word: "India" },
  ],
  story:
    "TASSEI was born from a simple belief — every Indian dream deserves an honest, end-to-end ecosystem that takes it all the way to safalta (success). From a rural student wanting to clear board exams, to a working professional aiming for an AI career, to a graduate looking for the right university — TASSEI brings coaching, certifications, mentorship and university partnerships under one roof.",
  mission:
    "To build India's No. 1 Career Success Ecosystem — and to educate India's rural youth by delivering awareness seminars in schools and colleges.",
  vision:
    "A nation where opportunity is decided by ability, not geography. Where every student has access to world-class learning, industry mentors and real placement support.",
  values: [
    { title: "Outcomes first", desc: "We measure ourselves by jobs landed, exams cleared and skills retained — not certificates printed." },
    { title: "Lifetime ownership", desc: "Once a TASSEI student, always one. Free practice access for life." },
    { title: "Rural-urban bridge", desc: "Awareness seminars in schools and colleges to make career clarity universal." },
    { title: "Honest counselling", desc: "We recommend the right course — even if it's not ours." },
  ],
};

export const CATEGORIES = [
  {
    id: "subjective",
    name: "Subjective Coaching",
    desc: "Class 5th to 12th Senior Secondary academic excellence with concept-first teaching.",
    stat: "5th – 12th",
    icon: "GraduationCap",
    image:
      "https://images.pexels.com/photos/16504588/pexels-photo-16504588.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "ai-computer",
    name: "AI-Powered Computer Education",
    desc: "11 flagship programs blending computer skills with AI — from productivity to full career accelerators.",
    stat: "11 Programs",
    icon: "Sparkles",
    image:
      "https://images.unsplash.com/photo-1677442136019-21780ecad995?auto=format&fit=crop&w=900&q=70",
  },
  {
    id: "short",
    name: "Short-term Programs",
    desc: "Focused short courses for rapid skill upgrades — Excel, design, typing, ChatGPT and more.",
    stat: "12 Programs",
    icon: "Timer",
    image:
      "https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&w=900&q=70",
  },
  {
    id: "professional",
    name: "Professional Programs",
    desc: "Career-focused certifications for working professionals and career switchers.",
    stat: "4 Programs",
    icon: "Briefcase",
    image:
      "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=900&q=70",
  },
  {
    id: "highered",
    name: "Higher Education Counselling",
    desc: "Admission counselling for distance & online degrees with 18+ University partners.",
    stat: "18+ Universities",
    icon: "School",
    image:
      "https://images.unsplash.com/photo-1714974528737-3e6c7e4d11af?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
];

export const COURSES = [
  // Subjective
  {
    id: "c-sub-foundation",
    category: "subjective",
    name: "Foundation Program (5th – 8th)",
    duration: "12 Months",
    image:
      "https://images.pexels.com/photos/8617769/pexels-photo-8617769.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    outcomes: [
      "Strong fundamentals in Maths & Science",
      "Improved English fluency",
      "Habit of regular practice",
    ],
  },
  {
    id: "c-sub-9-10",
    category: "subjective",
    name: "Board Mastery (9th – 10th)",
    duration: "10 Months",
    image:
      "https://images.pexels.com/photos/5212345/pexels-photo-5212345.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    outcomes: [
      "CBSE / State Board excellence",
      "Concept clarity in core subjects",
      "Confidence in exams",
    ],
  },
  {
    id: "c-sub-11-12",
    category: "subjective",
    name: "Senior Secondary (11th – 12th)",
    duration: "10 Months",
    image:
      "https://images.pexels.com/photos/6248995/pexels-photo-6248995.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    outcomes: [
      "Science / Commerce / Arts streams",
      "Board + entrance readiness",
      "Career path counselling",
    ],
  },

  // Computer Education
  {
    id: "c-cmp-dca",
    category: "computer",
    name: "Diploma in Computer Applications (DCA)",
    duration: "6 Months",
    image:
      "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?auto=format&fit=crop&w=900&q=70",
    outcomes: ["MS Office Mastery", "Internet & Email Pro", "Tally Basics"],
  },
  {
    id: "c-cmp-adca",
    category: "computer",
    name: "Advanced Diploma in Computer Applications (ADCA)",
    duration: "12 Months",
    image:
      "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=900&q=70",
    outcomes: ["Full Office Suite", "Tally Prime + GST", "Graphic Design Basics"],
  },
  {
    id: "c-cmp-tally",
    category: "computer",
    name: "Tally Prime with GST",
    duration: "3 Months",
    image:
      "https://images.pexels.com/photos/210990/pexels-photo-210990.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    outcomes: ["Bookkeeping", "GST Returns", "Payroll Setup"],
  },
  {
    id: "c-cmp-webdev",
    category: "computer",
    name: "Full Stack Web Development",
    duration: "6 Months",
    image:
      "https://images.unsplash.com/photo-1547658719-da2b51169166?auto=format&fit=crop&w=900&q=70",
    outcomes: ["HTML/CSS/JS", "React + Node", "Deploy real projects"],
  },

  // Short term
  {
    id: "c-st-typing",
    category: "short",
    name: "Hindi / English Typing Mastery",
    duration: "2 Months",
    image:
      "https://images.unsplash.com/photo-1587620962725-abab7fe55159?auto=format&fit=crop&w=900&q=70",
    outcomes: ["40+ WPM Typing", "Govt Exam Ready", "Certificate"],
  },
  {
    id: "c-st-office",
    category: "short",
    name: "MS Office Power User",
    duration: "1.5 Months",
    image:
      "https://images.unsplash.com/photo-1531403009284-440f080d1e12?auto=format&fit=crop&w=900&q=70",
    outcomes: ["Excel Formulas", "PowerPoint Pro", "Word Automation"],
  },
  {
    id: "c-st-spoken",
    category: "short",
    name: "Spoken English & Personality",
    duration: "3 Months",
    image:
      "https://images.unsplash.com/photo-1543269865-cbf427effbad?auto=format&fit=crop&w=900&q=70",
    outcomes: ["Fluency", "Public speaking", "Interview-ready"],
  },

  // AI
  {
    id: "c-ai-genai",
    category: "ai",
    name: "Generative AI for Everyone",
    duration: "2 Months",
    image:
      "https://images.unsplash.com/photo-1677442136019-21780ecad995?auto=format&fit=crop&w=900&q=70",
    outcomes: ["ChatGPT mastery", "Prompt engineering", "AI for productivity"],
  },
  {
    id: "c-ai-datasci",
    category: "ai",
    name: "AI & Data Science Foundation",
    duration: "6 Months",
    image:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=900&q=70",
    outcomes: ["Python + Pandas", "ML Basics", "Mini real-world project"],
  },
  {
    id: "c-ai-tools",
    category: "ai",
    name: "AI Tools for Business",
    duration: "1.5 Months",
    image:
      "https://images.unsplash.com/photo-1620712943543-bcc4688e7485?auto=format&fit=crop&w=900&q=70",
    outcomes: ["Marketing AI", "Design AI", "Workflow automation"],
  },

  // Professional
  {
    id: "c-pro-digital",
    category: "professional",
    name: "Digital Marketing Professional",
    duration: "6 Months",
    image:
      "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=900&q=70",
    outcomes: ["SEO + SEM", "Social Media", "Real campaigns"],
  },
  {
    id: "c-pro-graphic",
    category: "professional",
    name: "Graphic Design Professional",
    duration: "4 Months",
    image:
      "https://images.unsplash.com/photo-1626785774573-4b799315345d?auto=format&fit=crop&w=900&q=70",
    outcomes: ["Photoshop + Illustrator", "Brand design", "Portfolio building"],
  },
  {
    id: "c-pro-accounts",
    category: "professional",
    name: "Accounts Executive Pro",
    duration: "5 Months",
    image:
      "https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=900&q=70",
    outcomes: ["Tally + GST", "Income Tax basics", "Job-ready"],
  },

  // Higher Ed
  {
    id: "c-he-mba",
    category: "highered",
    name: "MBA / BBA / Master / Bachelor Degrees",
    duration: "2 – 3 Years",
    image:
      "https://images.pexels.com/photos/3184339/pexels-photo-3184339.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    outcomes: ["UGC-DEB approved", "Online / Distance mode", "18+ University choices"],
  },
  {
    id: "c-he-bca",
    category: "highered",
    name: "BCA / MCA Online",
    duration: "2 – 3 Years",
    image:
      "https://images.unsplash.com/photo-1573164713988-8665fc963095?auto=format&fit=crop&w=900&q=70",
    outcomes: ["Computer Applications degree", "Recognized universities", "Flexible learning"],
  },
  {
    id: "c-he-library",
    category: "highered",
    name: "MLIB / BLIB Library Science",
    duration: "1 – 2 Years",
    image:
      "https://images.unsplash.com/photo-1481627834876-b7833e8f5570?auto=format&fit=crop&w=900&q=70",
    outcomes: ["Library Science specialization", "Govt + private jobs", "Distance mode"],
  },
];

export const USPS = [
  {
    title: "Lifetime Free Practice",
    desc: "Once a TASSEI student, always a TASSEI student. Practice & revise as long as you want — at zero cost.",
    icon: "Infinity",
  },
  {
    title: "Job Assistance Till Placement",
    desc: "We don't stop at certification. We support you with interviews & openings until you land a job.",
    icon: "BriefcaseBusiness",
  },
  {
    title: "Personality Development Workshops",
    desc: "Hands-on workshops with industry experts to sharpen confidence, communication & presence.",
    icon: "Sparkle",
  },
  {
    title: "Interview Guidance with Experts",
    desc: "1-on-1 mock interviews & real-world prep led by hiring managers from top companies.",
    icon: "MessageSquareHeart",
  },
];

export const UNIVERSITIES = [
  "Amity University",
  "LPU",
  "Manipal University",
  "Sikkim Manipal",
  "Symbiosis",
  "IGNOU",
  "Jain University",
  "Chandigarh University",
  "Mangalayatan",
  "Vivekananda Global",
  "Subharti University",
  "Mangalore University",
  "NIILM University",
  "Bharathiar University",
  "Punjabi University",
  "Kurukshetra University",
  "Annamalai University",
  "MD University",
];

export const STATS = [
  { value: "20+", label: "AI-Powered Programs" },
  { value: "20+", label: "Certificate & Diploma" },
  { value: "18+", label: "University Partners" },
  { value: "100%", label: "Job Assistance" },
];

export const ALUMNI_COMPANIES = [
  "TCS",
  "Infosys",
  "Wipro",
  "HCL Tech",
  "Tech Mahindra",
  "Cognizant",
  "Capgemini",
  "Accenture",
  "IBM India",
  "Amazon",
  "Flipkart",
  "Reliance Industries",
  "Tata Steel",
  "Bajaj Finserv",
  "Zomato",
  "Swiggy",
  "Paytm",
  "BYJU'S",
  "PwC India",
  "Deloitte",
];

export const TESTIMONIALS = [
  {
    name: "Ritika Sharma",
    role: "ADCA Graduate · Joined a local accounting firm",
    quote:
      "I came from a small town with zero computer knowledge. TASSEI taught me Tally, MS Office and interview skills. I got my first job within 2 months of finishing the course.",
  },
  {
    name: "Aman Verma",
    role: "AI & Data Science Foundation · Junior Data Analyst",
    quote:
      "The AI course was hands-on from day one. My mentor reviewed my mini-project, helped me clean my resume and even did mock interviews. Sapno se safalta tak — literally.",
  },
  {
    name: "Priya Yadav",
    role: "Class 12th Student · CBSE 92%",
    quote:
      "Subjective coaching at TASSEI helped me understand Physics & Maths in a way school never did. Lifetime free practice is the best thing — I keep revising even now.",
  },
  {
    name: "Suraj Patel",
    role: "Digital Marketing Pro · Freelance Marketer",
    quote:
      "I run my own clients now. TASSEI didn't just give me a certificate — they gave me real campaigns to practice on and the confidence to talk to clients.",
  },
  {
    name: "Neha Singh",
    role: "Online MBA · Working Professional",
    quote:
      "I wanted an MBA but couldn't quit my job. TASSEI helped me pick the right university and walked me through admission. The whole process felt effortless.",
  },
  {
    name: "Rahul Kumar",
    role: "Spoken English Course · BPO Trainee",
    quote:
      "Earlier I was scared to speak English in interviews. After the personality workshop, I cleared 3 rounds and got placed in a top BPO. Thank you TASSEI!",
  },
];
